module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;

    ; __append("\r\n\r\n<input id=\"editableControl\" type=\"text\" name=\"text\" value=\"")
    ; __append( text )
    ; __append("\" maxLength=\"")
    ; __append(escapeFn( maxChars ))
    ; __append("\"\r\n    style=\" margin: 0px;\r\n            height: ")
    ; __append(escapeFn( u.extractNum(height)))
    ; __append("px;\r\n            width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px;\r\n            border: 0px solid black;\r\n            border-radius: 0;\r\n            padding: 0px;\r\n            text-align: ")
    ; __append(escapeFn( align ))
    ; __append(";\r\n            font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n            font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n            color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";\r\n            background-color: white;\"/>\r\n\r\n\r\n")
  }
  return __output;

}